var _desc, _defs, _path, _use, _use2, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "268px",
    height: "141px",
    viewBox: "0 0 268 141",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration-7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M134.5,4 L134.5,136",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 1,
    height: 132,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.862069,137.5 C249.862069,71.22583 197.988854,17.5 134,17.5 C70.0111462,17.5 18.137931,71.22583 18.137931,137.5",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 231.724138,
    height: 120,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-5",
    width: 4,
    height: 4,
    x: 130.999231,
    y: 80.5087357,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-6"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-6",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABGdBTUEAALGOfPtRkwAAAB1JREFUCB1j/A8EDBDACKKYoBw4xQJkgWVgIhgqAAb3BAgldYidAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Features-2",
    transform: "translate(-107.000000, -629.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration-7",
    transform: "translate(107.000000, 629.500000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.632447007,140.000701 L267.367553,140.000701 C267.455768,138.006364 267.5,136.005818 267.5,134 C267.5,60.2699859 207.730014,0.5 134,0.5 C60.2699859,0.5 0.5,60.2699859 0.5,134 C0.5,136.005818 0.544232349,138.006364 0.632447007,140.000701 Z",
    id: "Path",
    stroke: "#FFFFFF"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Line-7",
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    opacity: 0.400000006,
    strokeDasharray: 3,
    xlinkHref: "#path-1"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Path",
    stroke: "#FFFFFF",
    mask: "url(#mask-4)",
    strokeWidth: 2,
    opacity: 0.400000006,
    strokeDasharray: 3,
    xlinkHref: "#path-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5022055,140 L189.495942,140 L189.492563,139.582043 C189.001881,109.318197 164.309739,85 134,85 C103.515036,85 78.7706724,109.578432 78.5022055,140 Z",
    id: "Path",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135,140.5 L134.999231,84.5087357 C165.1615,85.0364941 189.50873,109.410974 189.992658,139.583912 L190,140.5 L135,140.5 L134.999231,84.5087357 L135,140.5 Z",
    id: "Path",
    fill: "url(#pattern-5)",
    style: {
      mixBlendMode: "exclusion"
    },
    opacity: 0.200000003
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4874632,130.574219 L18.1373891,138.054039 L22.7754655,130.574219 L13.4874632,130.574219 Z",
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.487463,130.574219 L134.137389,138.054039 L138.775465,130.574219 L129.487463,130.574219 Z",
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.487463,1.57421875 L134.137389,9.05403876 L138.775465,1.57421875 L129.487463,1.57421875 Z",
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    transform: "translate(134.130859, 5.538086) scale(1, -1) translate(-134.130859, -5.538086) "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.899573,130.574219 L249.549498,138.054039 L254.187575,130.574219 L244.899573,130.574219 Z",
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration7);
export default __webpack_public_path__ + "static/media/illustration-7.c97b5d143bcb2218011e477fda815875.svg";
export { ForwardRef as ReactComponent };